<template>
	<div class="modal fade" id="move_ferment" role="dialog" aria-labelledby="actionsTitle" aria-hidden="true">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
					<h4 class="modal-title" id="actionsTitle">Move Ferment</h4>
				</div>
				<div class="modal-body">
					<div class="row" v-if="!confirmSelection">
						<div class="col-xs-12">
							<input-select
								:select2="true"
								:inline="true"
								:options="fermenterOptions"
								name="destination_fermenter_id"
								:vmodel.sync="destinationFermenterId"
								label="Please select a destination tank">
							</input-select>
						</div>
					</div>
					<div class="row" v-else>
						<div class="col-xs-12" v-if="destinationFermenterIsEmpty">
							This will move this ferment to <strong>{{ destinationFermenterName }}</strong>. Do you want to continue?
						</div>
						<div class="col-xs-12" v-else>
							<strong>{{ destinationFermenterName }}</strong> already has a ferment running. This operation will blend them
							together. If you expected <strong>{{ destinationFermenterName }}</strong> to be empty, please go and archive that
							ferment first. Do you want to continue?

							<div class="alert alert-warning" v-if="destinationFermentMissingData">
								The destination ferment might be missing data. Make sure all data is entered on the blend components before blending.
								You won't be able to edit the individual component records once a blend is created.
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button v-if="!confirmSelection" type="button" class="btn btn-default" data-dismiss="modal">Close</button>
					<button v-else @click="cancelSelection" type="button" class="btn btn-default">Cancel</button>
					<button v-if="!destinationFermenterIsEmpty && confirmSelection" type="button" class="btn btn-success" @click="goToDestinationFerment">Go to {{ destinationFermenterName }}</button>
					<button @click="continue" type="button" class="btn btn-primary" :disabled="haveNoDestinationFermenter || continuing">Continue</button>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.alert.alert-warning {
	margin: 12px 0 0;
}
</style>

<script>
import { Fermenters as FermenterActions, Ferments as FermentActions } from 'vx/actions'
import { fermenters, fermenter, ferment, site } from 'vx/getters'
import Notify from 'utils/notify'
import moment from 'moment'

export default {
	props: ['index', 'day', 'measuringFreqInteger'],

	data () {
		return {
			destinationFermenterId: null,
			continuing: false,
			confirmSelection: false
		}
	},

	vuex: {
		actions: {
			allFermenters: FermenterActions.all,
			moveFerment: FermentActions.move
		},

		getters: {
			fermenters,
			fermenter,
			ferment,
			site
		}
	},

	computed: {
		fermenterOptions() {
			return this.fermenters.filter(fermenter => {
				return this.fermenter.id !== fermenter.id
					&& (!fermenter.currentFerment || fermenter.currentFerment.data.type === this.ferment.type)
			}).map(fermenter => {
				return { name: fermenter.name, value: fermenter.id }
			});
		},

		haveNoDestinationFermenter () {
			return !this.destinationFermenter
		},

		destinationFermenter () {
			return this.fermenters.find(fermenter => fermenter.id == this.destinationFermenterId)
		},

		destinationFermenterName () {
			if (this.destinationFermenter) {
				return this.destinationFermenter.name
			}

			return null
		},

		destinationFermenterIsEmpty () {
			if (this.haveNoDestinationFermenter) {
				return true
			}

			return this.destinationFermenter.currentFerment === undefined
		},

		destinationFermentMissingData () {
			if (this.destinationFermenterIsEmpty) {
				return false
			}

			let format = 'DD/MM/YYYY hh:mm A'
			let measuringFreq = 1 / this.measuringFreqInteger

			let blendDate = moment(this.ferment.start_date, format).add(24 * measuringFreq * this.index, 'hours')
			let blendDateDiff = blendDate.diff(moment(this.destinationFermenter.currentFerment.data.start_date, format), 'hours')

			let blendIndex = Math.floor(blendDateDiff / 24 / measuringFreq)

			return !(blendIndex in this.destinationFermenter.currentFerment.data.dailyData.data)
		}
	},

	ready() {
		$('#move_ferment').on('hidden.bs.modal', () => {
			this.continuing = false
			this.confirmSelection = false
			this.destinationFermenterId = null
		})
	},

	created() {
		this.allFermenters(this.site.id, ['currentFerment.dailyData'])
	},

	methods: {
		continue () {
			if (!this.confirmSelection) {
				this.confirmSelection = true
			} else {
				// Selection confirmed... process the move.
				this.continuing = true

				let payload = {
					destination_fermenter_id: this.destinationFermenterId,
					index: this.index,
					day: this.day
				}

				this.moveFerment(this.site.id, this.fermenter.id, this.ferment.id, payload)
					.then(response => {
						$('#move_ferment').modal('hide')

						this.$router.go({
							name: 'ferments.index',
							params: {
								fermenterId: response.data.data.fermenter_id,
								fermentId: response.data.data.id
							}
						});

						Notify.success('Successfully moved ferment.')
					})
					.catch(response => {
						if (response.status === 400) {
							Notify.error(response.body.message)
						}
					})
			}
		},

		cancelSelection () {
			this.confirmSelection = false
			this.destinationFermenterId = null
		},

		goToDestinationFerment () {
			$('#move_ferment').modal('hide')

			this.$router.go({
				name: 'ferments.index',
				params: {
					fermenterId: this.destinationFermenter.id,
					fermentId: this.destinationFermenter.currentFerment.data.id
				}
			});
		}
	}
}
</script>



// WEBPACK FOOTER //
// move-ferment.vue?56e43fba